import { PaymentMethodType } from '@nemuru-eng/js-api-client';

import { AutoLoanPaymentMethod } from '@/components/modules/Application/components/PaymentMethod/AutoLoan/entities/PaymentMethod/AutoLoanPaymentMethod';

export class B2BLoanPaymentMethod extends AutoLoanPaymentMethod {
  protected ALLOWED_PAYMENT_METHOD_TYPES = [PaymentMethodType.B2B_LOAN];
}
